module.exports = __webpack_public_path__ + "static/media/pccw solutions.6af3b322.png";